import {
  IonButton,
  IonCol,
  IonGrid,
  IonIcon,
  IonModal,
  IonRow,
  isPlatform,} from '@ionic/react';
import { star, starOutline } from 'ionicons/icons';
import React, { useEffect, useRef, useState } from 'react';
import { AppMessages } from '../../data/AppMessages';
import IDismissibleMessage from '../../interfaces/IDismissibleMessage';
import DismissibleMessageService from '../../services/DismissibleMessageService';
import Parser from 'ua-parser-js';
import './FeedbackModal.scss';

interface IFeedbackModalProps {
}

enum feedbackOptions {
  noThankyou,
  review,
  feedback,
}

const FeedbackModal: React.FC<IFeedbackModalProps> = (props) => {
  const [showFeedback, setShowFeedback] = useState(false);
  const [checkDB, setCheckDB] = useState(true);
  const [feedbackLevel, setFeedbackLevel] = useState(0);
  const [dbResponse, setDbResponse] = useState<IDismissibleMessage | undefined>(undefined);
  const feedBackProvided = useRef<boolean>(false);

  useEffect(() => {
    checkDbRecord();
    return () => {}
  }, []);

  const checkDbRecord = () => {
    if(isPlatform('hybrid')) {
      console.log('FeedBack Request', AppMessages.appFeedbackRequest.messageId, `${checkDB}`);
      if(checkDB) {
        DismissibleMessageService.getDismissibleMessage(AppMessages.appFeedbackRequest.messageId).then(result => {
          console.log('FeedBack Request: ', result);
          var todayDate = new Date();
          var fourMonthsAgo = new Date(todayDate.setMonth(todayDate.getMonth() - 4));
          if(result.Success && result.Data?.dismissed) {
            setDbResponse(result.Data);
            setCheckDB(false);
            setShowFeedback(false);
            console.log('FeedBack Request ' + AppMessages.appFeedbackRequest.messageId + ' found.', result.Data?.dateDisplayed);
          } else if(result.Success && result.Data && result.Data?.dateDisplayed < fourMonthsAgo) {
            setDbResponse(result.Data);
            setCheckDB(false);
            setShowFeedback(true);
            console.log('FeedBack Request ' + AppMessages.appFeedbackRequest.messageId + ' found.', result.Data?.dateDisplayed);
          } else if(!result.Success) {
            setCheckDB(false);
            setShowFeedback(true);
            console.log('FeedBack Request ' + AppMessages.appFeedbackRequest.messageId + ' show.', result?.Data?.dateDisplayed);
          } else {
            setCheckDB(false);
            setShowFeedback(false);
          }
        });
      }
    }
  }

  const provideFeedback = (response: feedbackOptions, rating: number) => {
    // use for pop up
    // https://github.com/dpa99c/cordova-launch-review

    // prevent this from executing more than once in a session
    if(!feedBackProvided.current) {
      feedBackProvided.current = true;
    
      // Never show again if they choose to review or they don't like the app and don't want to tell us
      const dismissed = response === feedbackOptions.review || (rating < 4 && response === feedbackOptions.noThankyou) || (!!dbResponse && dbResponse.timesDisplayed > 2);
      let todayDate = new Date(Date.now());

      // Date Testing Code 5 months earlier
      // todayDate = new Date(todayDate.setMonth(todayDate.getMonth() - 5));

      const dismissMessage: IDismissibleMessage = {
        messageId: AppMessages.appFeedbackRequest.messageId,
        category: 'feedback',
        timesDisplayed: 1,
        dateDisplayed: todayDate,
        dismissed,
      }

      if(dbResponse) {
        dismissMessage.id = dbResponse.id;
        dismissMessage.timesDisplayed = dbResponse.timesDisplayed + 1;
        DismissibleMessageService.updateDismissibleMessage(dismissMessage).then(
          result => {
            if(result.Success) {
              feedBackAction(response);
            }
          }); 
      } else {
        DismissibleMessageService.logDismissibleMessage(dismissMessage).then(
          result => {
            if(result.Success) {
              feedBackAction(response);
            }
          }); 
      }
    }
  }

  const feedBackAction = (response: feedbackOptions) => {
    switch(response){
      case feedbackOptions.review:
        // link to review page
        const userAgent = Parser(navigator.userAgent)
        switch(userAgent.device.vendor){
          case 'Apple':
            window.open('itms-apps://itunes.apple.com/app/1331946347?action=write-review');
            break;
          case 'Amazon':
            window.open('amzn://apps/android?p=net.synergyts.bst');
            break;
          default:
            // Google
            window.open('market://details?id=net.synergyts.bst');
            break;
        }
        break;
      case feedbackOptions.feedback:
        window.open('https://biblestudytogether.com/contact-us-app-help/');
        break;
      default:
        console.log('Feedback Dismissed');
    }
    setShowFeedback(false);
  }
  

  return (
    <IonModal id="feedback-modal" isOpen={showFeedback} onDidDismiss={() => provideFeedback(feedbackOptions.noThankyou, 5)}>
      <IonGrid className="wrapper">
        <IonRow>
          <IonCol>
            <h1>Please give us some feedback...</h1>
            <div>
              <IonIcon icon={feedbackLevel >= 1 ? star : starOutline} onClick={() => setFeedbackLevel(1)}></IonIcon>
              <IonIcon icon={feedbackLevel >= 2 ? star : starOutline} onClick={() => setFeedbackLevel(2)}></IonIcon>
              <IonIcon icon={feedbackLevel >= 3 ? star : starOutline} onClick={() => setFeedbackLevel(3)}></IonIcon>
              <IonIcon icon={feedbackLevel >= 4 ? star : starOutline} onClick={() => setFeedbackLevel(4)}></IonIcon>
              <IonIcon icon={feedbackLevel >= 5 ? star : starOutline} onClick={() => setFeedbackLevel(5)}></IonIcon>
            </div>
            <div className="feedback-modal-request">
            { feedbackLevel !== 0 && 
              <p>THANK YOU!</p>
            }
            { feedbackLevel !== 0 &&
              (feedbackLevel === 5 ?
              <span>Please help more people find this app by reviewing it in the app store.</span> :
              <span>Please provide us with feedback on how to improve the app.</span>)
            }
            </div>
          </IonCol>
        </IonRow>
        { feedbackLevel === 5 ?
          <IonRow>
            <IonCol>
              <IonButton color="primary" expand="block" onClick={()=>provideFeedback(feedbackOptions.noThankyou, feedbackLevel)}>No Thank You</IonButton>
            </IonCol>
            <IonCol>
              <IonButton color="tertiary" expand="block" onClick={()=>provideFeedback(feedbackOptions.review, feedbackLevel)}>Review App Now!</IonButton>
            </IonCol>
          </IonRow> : 
          feedbackLevel !== 0 ?
          <IonRow>
            <IonCol>
              <IonButton color="primary" expand="block" onClick={()=>provideFeedback(feedbackOptions.noThankyou, feedbackLevel)}>No Thank You</IonButton>
            </IonCol>
            <IonCol>
              <IonButton color="secondary" expand="block" onClick={()=>provideFeedback(feedbackOptions.feedback, feedbackLevel)}>Provide Feedback</IonButton>
            </IonCol>
          </IonRow> : null
        }
        
      </IonGrid>
    </IonModal>
  );
};

export default FeedbackModal;